import $service from '@/common/service/api-service';
import $config from '@/config';
function reLogin(res,args={}) {
  res=res.code?res:res.data;
  args.callback?args.callback.call(this,res):'';
}
export default{
  namespaced:true,
  state:{
    packages:[],
    orderInfo:{},
    payResult:{},
    orderList:[]
  },
  mutations:{
    setPackages(state,packages){
      state.packages=packages;
    },
    setOrderInfo(state,info){
      state.orderInfo=info;
    },
    setPayResult(state,result){
      state.payResult=result;
    },
    setOrderList(state,list){
      state.orderList=list;
    }
  },
  actions:{
    pullOrderPackages(context,args={}){
      $service.get('/so/order/getPackage/email').then(res=>{
        if(res.code==1){
          context.commit('setPackages',res.data);
        }
        reLogin(res,args);
      })
    },
    pullOrderInfo(context,args={}){
      $service.post('/so/order',args.data).then(res=>{
        if(res.code==1){
          context.commit('setOrderInfo',res.data);
        }
        reLogin(res,args);
      })
    },
    reloadOrderInfo(context,args={}){
      $service.get('/so/order/getOrder/'+args.data).then(res=>{
        if(res.code==1){
          context.commit('setOrderInfo',res.data);
        }
        reLogin(res,args);
      })
    },
    pay(context,args={}){
      $service.post('/so/order/pay',args.data).then(res=>{
        if(res.code==1){
          context.commit('setPayResult',res.data);
        }
        reLogin(res,args);
      })
    },
    cancelOrder(context,args={}){
      $service.post('/so/order/cancel',args.data).then(res=>{
        reLogin(res,args);
      })
    },
    pullOrderList(context,args={}){
      $service.get('/so/order/list',args.data).then(res=>{
        if(res.code==1){
          context.commit('setOrderList',res.data);
        }
        reLogin(res,args);
      })
    },
    deleteOrderRecord(context,args={}){
      $service.del('/so/order/delete',args.data).then(res=>{
        reLogin(res,args);
      })
    },
    checkWxPay(context,args={}){
      $service.get('/so/order/refreshWXPay/'+args.data).then(res=>{
        reLogin(res,args);
      })
    },
    sendThirdOrderNo(context,args={}){
      $service.post('/so/order/saveThirdTradeNo',args.data).then(res=>{
        reLogin(res,args);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account/index.js